import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ForecastWeekEditable } from '../../services/forecast-week-editable.service';
import { CampaignUpdate } from '../forecast-week/CampaignUpdate';

function isMonday(date = new Date()) {
	return date.getDay() === 1;
}

function isSunday(date = new Date()) {
	return date.getDay() === 0;
}

@Component({
	selector: 'app-income-week',
	templateUrl: './income-week.component.html',
	styleUrls: ['./income-week.component.scss'],
})
export class IncomeWeekComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;

	private campaingUpdate: CampaignUpdate = new CampaignUpdate(0, 0, 0);
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	isHidden: boolean = false;
	public selectedCampaign: number;
	public selectedTypeCampaign: string;
	keyword = 'name';
	isSearch: boolean = false;
	fechas: any;

	constructor(private forecastWeekEditable: ForecastWeekEditable) {}

	ngAfterViewInit() {
		const monday_1 = getNextMonday(new Date(), 7).toDateString().slice(4);
		const monday_2 = getNextMonday(new Date(), 14).toDateString().slice(4);
		const monday_3 = getNextMonday(new Date(), 21).toDateString().slice(4);
		const monday_4 = getNextMonday(new Date(), 28).toDateString().slice(4);
		const monday_5 = getNextMonday(new Date(), 35).toDateString().slice(4);
		const monday_6 = getNextMonday(new Date(), 42).toDateString().slice(4);
		const monday_7 = getNextMonday(new Date(), 49).toDateString().slice(4);
		const monday_8 = getNextMonday(new Date(), 56).toDateString().slice(4);

		var promise = Promise.resolve(
			this.forecastWeekEditable.getForecastIncomeWeek(),
		);

		promise.then((val) => {
			var tableYear = jspreadsheet(this.sheet.nativeElement, {
				data: val.body,
				csvHeaders: true,
				search: true,
				pagination: 100,
				tableOverflow: true,
				freezeColumns: 3,
				tableWidth: '1100px',
				tableHeight: '1100px',
				columns: [
					{ title: 'Row', width: 80, type: 'hidden', readOnly: true },
					{
						title: 'Campaign ID',
						width: 80,
						type: 'hidden',
						readOnly: true,
					},
					{ title: 'Campaign', width: 100, readOnly: true },
					{ title: 'Industry', width: 100, readOnly: true },
					{
						title: 'Lead Cost',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},

					{
						title: 'Leads',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Reschedule',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Replacement',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
				],
				footers: [
					[
						'',
						'',
						'',
						'',
						'Total',
						'=ROUND(SUM(F1:F300),2)',
						'=ROUND(SUM(G1:G300),2)',
						'=ROUND(SUM(H1:H300),2)',
						'=ROUND(SUM(I1:I300),2)',
						'=ROUND(SUM(J1:J300),2)',
						'=ROUND(SUM(K1:K300),2)',
						'=ROUND(SUM(L1:L300),2)',
						'=ROUND(SUM(M1:M300),2)',
						'=ROUND(SUM(N1:N300),2)',
						'=ROUND(SUM(O1:O300),2)',
						'=ROUND(SUM(P1:O300),2)',
						'=ROUND(SUM(Q1:O300),2)',
						'=ROUND(SUM(R1:O300),2)',
						'=ROUND(SUM(S1:O300),2)',
						'=ROUND(SUM(T1:O300),2)',
						'=ROUND(SUM(U1:O300),2)',
						'=ROUND(SUM(V1:O300),2)',
						'=ROUND(SUM(W1:O300),2)',
						'=ROUND(SUM(X1:O300),2)',
						'=ROUND(SUM(Y1:O300),2)',
						'=ROUND(SUM(Z1:O300),2)',
						'=ROUND(SUM(AA1:O300),2)',
						'=ROUND(SUM(AB1:O300),2)',
						'=ROUND(SUM(AC1:O300),2)',
					],
				],
				nestedHeaders: [
					[
						{
							title: 'Campaign Info',
							colspan: 3,
						},
						{
							title: monday_1,
							colspan: 3,
						},
						{
							title: monday_2,
							colspan: 3,
						},
						{
							title: monday_3,
							colspan: 3,
						},
						{
							title: monday_4,
							colspan: 3,
						},
						{
							title: monday_5,
							colspan: 3,
						},
						{
							title: monday_6,
							colspan: 3,
						},
						{
							title: monday_7,
							colspan: 3,
						},
						{
							title: monday_8,
							colspan: 3,
						},
						{
							title: 'Totals',
							colspan: 4,
						},
					],
				],

				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {
					if (col > 4 && col < 29) {
						if (val == 0) {
							cell.style.backgroundColor = '#fff8b0';
						} else {
							cell.style.backgroundColor = '#edfccf';
						}
					}
				},
			});
		});
	}

	selectEventCampaign(item: any) {
		this.selectedCampaign = item.id;
	}

	get_week_filter(event: any) {
		let firstDate = event.target.selectWeek.value.substring(0, 10);
		let lastDate = event.target.selectWeek.value.substring(14, 24);
		let selectedCampaign = this.selectedCampaign;
		let selectedTypeCampaign = this.selectedTypeCampaign;

		let checkMonday = isMonday(new Date(firstDate + ' 00:00:00'));
		let checkSunday = isSunday(new Date(lastDate + ' 00:00:00'));

		if (checkMonday == true && checkSunday == true) {
			this.isHidden = false;
			this.isSearch = true;
		} else {
			this.isHidden = true;
			this.isSearch = false;
		}
	}
}
function getNextMonday(date = new Date(), int: number) {
	const dateCopy = new Date(date.getTime());

	const nextMonday = new Date(
		dateCopy.setDate(
			dateCopy.getDate() + ((int - dateCopy.getDay() + 1) % int || int),
		),
	);

	return nextMonday;
}
